import { StartPositionType, StreamInfo, StreamInfoType } from './StreamInfo';
import { calculateStartTime } from './StreamInfoUtility';
import { Bookmark } from '../logicHandlers/Bookmark';
import { VodAsset } from '../../detail/vod/VodAsset';
import { OttStream } from '../../detail/vod/VodStreamRights';
import { IBookmarkElementV1 } from '../../../api/models/AndromeTV.types';
import { VodAssetStreamType } from '../../detail/detail.types';

export class VodStreamInfo extends StreamInfo {
  private _vod: VodAsset;
  private _vodStream: OttStream;
  private _startPositionType: number;

  constructor(vod: VodAsset, vodStream: OttStream, bookmark: IBookmarkElementV1 | undefined, startPosition: number) {
    super();
    this._vod = vod;
    this._vodStream = vodStream;
    this.bookmark = Bookmark.fromVod(vod, bookmark ? bookmark.position : 0);
    this._startPositionType = startPosition;
  }

  override get isAdult() {
    return this._vod.adult;
  }

  override get assetId() {
    return this._vod.assetId;
  }

  override get resourceId() {
    return this._vodStream.getStreamId();
  }

  override get type() {
    return StreamInfoType.VOD;
  }

  override get vodStreamId() {
    return this._vodStream.getStreamId();
  }

  override get titleText() {
    return this._vod.text.title || '';
  }

  override get streamType() {
    return this._vodStream.getStreamType();
  }

  override get startPositionTime() {
    const start = this._startPositionType === StartPositionType.START ? 0 : this.bookmark?.value.position ?? 0;
    return calculateStartTime(start, this.currentAsset?.bookmarkOffset);
  }

  override get quoteId() {
    const quote = this._vodStream.selectValidQuote();
    return quote ? quote.quoteId : undefined;
  }

  override updateBookmark(position: number, duration: number) {
    this.bookmark?.updateTime(position, duration);
    if (this._vodStream.stream && this._vodStream.stream.streamType === VodAssetStreamType.TRAILER) {
      return false;
    }
    return true;
  }

  override get episode(): number | undefined {
    return this._vod.episodeNumber;
  }

  override get season(): number | undefined {
    return this._vod.seasonNumber;
  }

  override updateStartPositionType(type: number) {
    this._startPositionType = type;
  }

  override get canAutoPlay() {
    return this._vodStream.stream.streamType !== VodAssetStreamType.TRAILER;
  }
}
